<template>
  <v-row class="mb-6 pa-0 mx-0">
    <a :class="'anchor category-' + catItem.id" :id="catItem.name" />
    <v-col cols="12 px-0">
      <HitechHeader
        :catName="catItem.name"
        :catCode="catItem.id"
        :icon="catIcon(catItem.id)"
      />
    </v-col>

    <v-col class="px-4 py-3 areas-box pb-0">
      <v-row align="center">
        <HitechSubCatItem v-for="(item , index) in catItem.sub_categories" :key="index" :subCategory="item" />
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-divider class="mb-2"></v-divider>
          <HitechCategoryFooter
            :catCode="catItem.id"
            :catName="catItem.name"
          />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import HitechHeader from '@/components/HitechCategories/HitechHeader'
import HitechSubCatItem from '@/components/HitechCategories/HitechSubCatItem'
import HitechCategoryFooter from '@/components/HitechCategories/HitechCategoryFooter'

export default {
  components: { HitechHeader, HitechSubCatItem, HitechCategoryFooter },

  props: {
    catItem: {
      type: Object,
      required: false,
      default: () => {}
    }
  },

  data() {
    return {
      showMoreSubCats: false
    }
  },

  created() {},

  mounted() {},

  computed: {},
  methods: {
    catIcon(code) {
      switch (code) {
        case 30:
          return 'icon-security'
        case 28:
          return 'icon-internet'
        case 24:
          return 'icon-browser'
        case 4:
          return 'icon-cpu'
        case 5:
          return 'icon-monitor'
        case 6:
          return 'icon-coding'
        default:
          return 'icon-monitor'
      }
    },
    showMore() {
      this.showMoreSubCats = !this.showMoreSubCats
    }
  }
}
</script>

<style lang="scss" scoped>
a.anchor {
  display: block;
  position: relative;
  top: -150px;
  visibility: hidden;
}
.areas-box {
  border: 1px solid $gray-border;
}

</style>